<template lang="pug">
div.page
  div.exist-favorite-items(v-if="favoriteItems.length")
    div.title-area
      p お気に入り一覧
    div.items-area
      div.item-area(v-for="item in favoriteItems")
        div.item-image-area
          img(:src="item.imagePath" @click="goResult(item)")
        div.item-name-area
            heart(:favorited.sync="item.favorited" )
            p(@click="goResult(item)") {{item.name}}
  div.no-exist-favorite-items(v-else)
    p.desc 現在お気に入りに登録済みの商品はございません
  div.button-area
    button.negative(@click="$router.push('/redirect')") 他の商品を読み取る
  footer-nav
</template>

<script>
import heart from "@/components/Heart";
import FooterNav from "@/components/FooterNav";

export default {
  components: {
    heart,
    FooterNav: FooterNav
  },
  data() {
    return {
      favoriteItems: JSON.parse(localStorage.getItem("favoriteItems")) || [] // ローカルストレージに保存している配列
    };
  },
  beforeDestroy() {
    // お気に入り登録フラグを参照し商品情報を削除、ストレージに保存
    this.favoriteItems = this.favoriteItems.filter(item => item.favorited);
    localStorage.setItem("favoriteItems", JSON.stringify(this.favoriteItems));
  },

  methods: {
    goResult(item) {
      this.$router.push({
        name: "result",
        params: { jan: item.jan },
        hash: "#fromFavorite"
      });
    }
  }
};
</script>
<style lang="sass" scoped>
.page
  display: flex
  flex-direction: column
  min-height: 100vh
.title-area
  p
    padding-top: 6%
    padding-left: 7%
    font-size: 2vmax
    font-weight: bold
.items-area
  padding-top: 1%
.item-area
  height: auto
  min-height: 19.8vh
  display: flex
  .item-image-area
    padding-top: 1%
    width: 30%
    padding-left: 7%
    img
      width: 100%
      height: auto
      border-radius: 1vh
      border: 1px solid
  .item-name-area
    padding-top: 3%
    padding-left: 7%
    min-width: 50%
    max-width: 50%
    font-size: 2vmax
    /deep/ svg
      height: 120%
      width: 120% !important
    p
      margin-top: 1.8vh
.no-exist-favorite-items
  padding: 10vh 6.3vh
  .desc
    font-weight: bold
.button-area
  padding-top: 5%
  padding-bottom: 5%
  button
    display: block
    margin: auto
    border-radius: 2em
    width: 49vw
    height: 6vmax
    font-size: 2vmax
</style>
